// extracted by mini-css-extract-plugin
export default {"root":"IconCard_root__CPWTY","icon":"IconCard_icon__26qW+","plus":"IconCard_plus__vKylG"};